import "./breadcrumbs.scss";

(function () {
    if (document.querySelectorAll(".js-breadcrumbs").length > 0) {

        const breadcrumbs = {
            init: function () {
                const breadcrumbItems = document.querySelectorAll(".js-breadcrumbs-container");

                breadcrumbItems.forEach((breadcrumbItem) => {
                    const overflowIcon = breadcrumbItem.querySelector(".js-has-overflow");

                    const overflowing = breadcrumbs.isOverFlowing(breadcrumbItem);

                    if (overflowing) {
                        overflowIcon.style.display = "flex";
                        breadcrumbs.removeListItem(breadcrumbItem);
                    }
                });
            },
            removeListItem: (item) => {
                const listItem = item.querySelector(".js-breadcrumbs-list");
                const items = listItem.querySelectorAll("li");
                const lastItemIndex = items.length - 1;

                if (listItem !== null) {
                    for (let i = 0; i < items.length; i++) {
                        const overflow = breadcrumbs.isOverFlowing(item);

                        if (overflow) {
                            if (i !== lastItemIndex) {
                                items[i].remove();
                            }
                        }
                    }
                }
            },
            isOverFlowing: (item) => {
                const scroll = item.querySelector(".js-breadcrumbs-list");
                const scrollContainer = item;
                const overflowIcon = item.querySelector(".js-has-overflow");

                if (scroll.scrollWidth > (scrollContainer.offsetWidth - overflowIcon.offsetWidth)) {
                   return true
                }
                else {
                    return false
                }
            },
        };

        breadcrumbs.init();
    }
})();
